import { render, staticRenderFns } from "./userPerformanceChart.vue?vue&type=template&id=10a3ed31&"
import script from "./userPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./userPerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports